const KEY = 'recently_viewed';
const MAX = 12;

export function getRecentlyViewed() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
}

export function addRecentlyViewed(productId) {
  try {
    const next = [productId, ...getRecentlyViewed().filter(id => id !== productId)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {}
}
